var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8398 6.05642C21.8834 5.79174 21.8552 5.5202 21.7582 5.2701C21.6612 5.02 21.4989 4.80048 21.2883 4.63443C21.0776 4.46838 20.8262 4.36186 20.5604 4.32598C20.2945 4.2901 20.0239 4.32616 19.7768 4.43042L2.67678 11.6304C1.48478 12.1324 1.42378 13.8564 2.67678 14.3764C3.91767 14.8934 5.17646 15.3664 6.45078 15.7944C7.61878 16.1804 8.89278 16.5374 9.91378 16.6384C10.1928 16.9724 10.5438 17.2944 10.9018 17.5884C11.4488 18.0384 12.1068 18.5014 12.7868 18.9454C14.1488 19.8354 15.6598 20.6864 16.6778 21.2404C17.8948 21.9004 19.3518 21.1404 19.5698 19.8134L21.8398 6.05642ZM4.59378 12.9934L19.7178 6.62542L17.5998 19.4654C16.6008 18.9224 15.1618 18.1094 13.8798 17.2714C13.2889 16.892 12.7185 16.4818 12.1708 16.0424C12.0244 15.9228 11.8823 15.7981 11.7448 15.6684L15.7058 11.7084C15.8934 11.5209 15.9989 11.2665 15.999 11.0013C15.9991 10.736 15.8938 10.4816 15.7063 10.2939C15.5188 10.1063 15.2644 10.0008 14.9991 10.0007C14.7339 10.0006 14.4794 10.1059 14.2918 10.2934L9.95478 14.6304C9.22078 14.5364 8.19878 14.2644 7.07678 13.8944C6.2415 13.6161 5.41386 13.3153 4.59478 12.9924L4.59378 12.9934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8129a822a4fa6f07bc557c5306894dc8.svg";
export { ForwardRef as ReactComponent };